import { Component, Input, OnInit } from '@angular/core';
import { AtsResumeScreenService } from '../_services/ats-resume-screen.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-person-search-document-slider',
    templateUrl: './person-search-document-slider.component.html',
    styleUrls: ['./person-search-document-slider.component.scss'],
    standalone: false
})
export class PersonSearchDocumentSliderComponent implements OnInit {

  @Input() candidateDetails: any;
  candidateDocuments: any[] = [];
  previewresumeurl: any = null;
  downloadpreviewresumeurl: any = null;
  selectedDocument: string = null;
  filename: string = '';
  constructor(private atsResumeScreenService: AtsResumeScreenService) { }

  ngOnInit(): void {
    this.candidateDocuments = this.candidateDetails?.doc_urls || [];
    this.selectedDocument = this.candidateDocuments.length > 0 ? this.candidateDocuments[0].url : null;
    this.filename = this.candidateDocuments.length > 0 ? this.candidateDocuments[0].filename : '';
    // this.getPreviewLink();
    this.getPreviewDocument();

  }


  getFileName(filename: any): string {
    if (!filename) return '';

    if (Array.isArray(filename)) {
      return filename[0];
    }

    if (typeof filename === 'string') {
      try {
        const parsed = JSON.parse(filename);
        if (Array.isArray(parsed)) {
          return parsed[0];
        }
      } catch (e) {
      }
    }

    return filename;
  };

  getPreviewLink() {
    this.atsResumeScreenService.previewCandidateResume(this.candidateDetails.id, this.selectedDocument).subscribe((res: any) => {
      // let apiresp = res;
      // var file3 = new Blob([apiresp], { type: 'application/pdf' });
      // this.previewresumeurl = (URL.createObjectURL(file3) + "#toolbar=0&navpanes=0&scrollbar=0");
      this.previewresumeurl = (URL.createObjectURL(res) + "#toolbar=0&navpanes=0&scrollbar=0");
    })
  }

  getPreviewDocument() {
    this.atsResumeScreenService.getPreviewCandidateDoc(this.candidateDocuments[0]).subscribe((res: any) => {
      let apiresp = res;
      // var file3 = new Blob([apiresp], { type: 'application/pdf' });
      // this.downloadpreviewresumeurl = (URL.createObjectURL(file3) + "#toolbar=0&navpanes=0&scrollbar=0");
      this.downloadpreviewresumeurl = (URL.createObjectURL(res) + "#toolbar=0&navpanes=0&scrollbar=0");

    })
  };

  downloadDocument() {
    this.atsResumeScreenService.previewCandidateResume(this.candidateDetails.id, this.selectedDocument)
      .subscribe((res: Blob) => {
        const downloadUrl = URL.createObjectURL(res);
        const downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.download = this.getFileName(this.filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(downloadUrl);
      }, (error) => {
        console.error('Download failed:', error);
      });
  }

  onDocumentChange(event: any) {
    this.filename = this.candidateDocuments.find(doc => doc.url.toLowerCase().trim() === this.selectedDocument.toLowerCase().trim())?.filename || '';
    this.getPreviewDocument();
  }

}
